import { validateEmail } from 'shared';

import { CreatablePropertyUser } from './types';

export function isCreatablePropertyUser(user: Partial<CreatablePropertyUser>): user is CreatablePropertyUser {
  const { firstname, lastname, email, calling_code, phone } = user;

  return !!firstname && !!lastname && !!validateEmail(email, true).valid && !!calling_code && !!phone;
}
